import { Row, Typography, Button, Empty } from "antd";
import ProductCard from "./ProductCard";
import { useCart } from "../context/CartContext";

const { Title } = Typography;

export default function Section({
  title,
  data = [],
  onViewAll,
  loading = false,
  onProductClick, // 🔥 NEW PROP
}) {
  const { items } = useCart(); // ✅ global cart

  return (
    <div style={{ marginTop: 30 }}>
      {/* Header */}
      <Row justify="space-between" align="middle">
        <Title level={4} style={{ margin: 0 }}>
          {title}
        </Title>

        <Button type="link" onClick={onViewAll}>
          View All
        </Button>
      </Row>

      {/* Content */}
      {loading ? (
        <div style={{ marginTop: 20 }}>Loading...</div>
      ) : data.length === 0 ? (
        <Empty style={{ marginTop: 20 }} description="No Products Found" />
      ) : (
        <div
          style={{
            display: "flex",
            overflowX: "auto",
            gap: 16,
            marginTop: 20,
          }}
        >
          {data.slice(0, 10).map((item) => (
            <div
              key={item.id}
              style={{
                flex: "0 0 220px", // 🔥 FIXED WIDTH
                maxWidth: 260, // optional safety
              }}
            >
              <ProductCard
                product={item}
                cartItems={items}
                onDetail={() => onProductClick(item)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
